import * as ACTION from '../actions/actionTypes';
import { UpdateObject } from '../../utils/utils';

const initialState = {
    loading: false,
    errorMsg: '',
    exceptionData:[],
   // calendarData:[]
}

const ExceptionReducer = (state = initialState, action) => {
    switch(action.type) {
       
        case ACTION.GET_EXCEPTION_REQUEST: return getExceptionRequest(state, action);
        case ACTION.GET_EXCEPTION_SUCCESS: return getExceptionSuccess(state, action);
        case ACTION.GET_EXCEPTION_FAILURE: return getExceptionFailure(state, action);
        
        default: return state;
    }
}

const getExceptionRequest = (state, action) => {
    return UpdateObject(state, {
        loading: true,
    });
}
const getExceptionSuccess = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        exceptionData: action.payload,
    });
}
const getExceptionFailure = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        errorMsg: action.payload,
    });
}

export default ExceptionReducer;